import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import Icon from "./icons/Icon";
import "./QrKarte.css";

/** Link, ueber den Mitspieler direkt beim Namen landen. */
export const beitrittsLink = (code) => `${window.location.origin}/?join=${code}`;

/**
 * "Link teilen": Teilen-Menue des Handys, sonst Link in die Zwischenablage.
 * Gibt [kopiert, teilen] zurueck — kopiert ist kurz true nach dem Kopieren.
 */
export function useTeilen(code) {
  const [kopiert, setKopiert] = useState(false);
  const link = beitrittsLink(code);
  const teilen = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: "Vinyl Showdown", text: `Spiel mit! Code ${code}`, url: link });
        return;
      }
    } catch (e) {
      // Abgebrochen: nichts tun. Andere Fehler: unten kopieren.
      if (e && e.name === "AbortError") return;
    }
    try {
      await navigator.clipboard.writeText(link);
      setKopiert(true);
      setTimeout(() => setKopiert(false), 2500);
    } catch (e) {
      /* Kein Zugriff aufs Clipboard: der Code steht ja gross daneben */
    }
  };
  return [kopiert, teilen];
}

/**
 * Code + QR fuer die Lobby. "Link teilen" oeffnet das Teilen-Menue des
 * Handys; wo es das nicht gibt (Laptop), wird der Link kopiert.
 * @category spiel
 */
export function QrKarte({ code }) {
  const [kopiert, teilen] = useTeilen(code);
  const link = beitrittsLink(code);

  return (
    <div className="qr-karte">
      <div className="qr-bild">
        <QRCodeSVG value={link} size={112} level="M" />
      </div>
      <div className="qr-text">
        <small>Code</small>
        <b>{code}</b>
        <span>{window.location.host}</span>
        <button type="button" className="qr-teilen" onClick={teilen}>
          <Icon name={kopiert ? "check" : "teilen"} size={18} />
          {kopiert ? "Link kopiert" : "Link teilen"}
        </button>
      </div>
    </div>
  );
}

export default QrKarte;
